import { IMockProps, ErrorResponseCodeType } from '_core/types';
import { ENDPOINT_API_PATH, CODE_ERRORS } from '../Definitions/PartnerTokenDef';

const autoGenerateSuccess = (type: string) => {
  const validateDocumentSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        type,
      },
    },
    configResponse: {
      status: 200,
      data: {
        code: 0,
        dataToken: {
          redirectURL: 'https://www.shoppingsmiles.com.br',
        },
      },
    },
  };
  return validateDocumentSuccess;
};

const autoGenerate = (type: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'GET',
          path: ENDPOINT_API_PATH,
          body: {
            type,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};

const autoGenerateResponse = autoGenerateSuccess('smiles-shopping');

const generatedSuccessMocks = [autoGenerateResponse];

const autoGenerateErrorsMock = () => {
  const errorPartner = autoGenerate('smiles-atracoes');
  return [...errorPartner];
};

const errorsGenerated = autoGenerateErrorsMock();

const Mocks = [...generatedSuccessMocks, ...errorsGenerated];

export default Mocks;
